import { render } from "./modalInvRec.vue?vue&type=template&id=017bdd44&scoped=true"
import script from "./modalInvRec.vue?vue&type=script&lang=js"
export * from "./modalInvRec.vue?vue&type=script&lang=js"

import "./modalInvRec.vue?vue&type=style&index=0&id=017bdd44&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017bdd44"]])

export default __exports__